import { FC } from "react";
import CircularProgress from "@mui/material/CircularProgress"


interface IProps {
    color?: string;
    visible: boolean;
}

const Loading: FC<IProps> = ({ color, visible }) => {
    return (
        <>
            {
                visible && <div style={{
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 1900,
                    width: "100%",
                    height: "100%",
                    margin: "auto",
                    display: "flex",
                    position: "fixed",
                    minHeight: "100vh",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                }}>
                    <div style={{
                        width: 100, height: 100, justifyContent: "center", display: "flex",
                        alignItems: "center", backgroundColor: "#ffffff", borderRadius: 12, border: 1
                    }}>
                        <CircularProgress style={{ color: color ?? "#3b82f6" }} />
                    </div>
                </div>
            }
        </>
    );
};

export default Loading